import { OrderFragment } from '@graphql/fragments';
import { gql } from 'graphql-request';

export const getOrder = gql`
  ${OrderFragment}
  query SearchOrder($order: String!, $email: String!) {
    searchOrder(orderNumber: $order, customerEmail: $email) {
      ...Order
    }
  }
`;
